import React from "react";
import { BsDot } from "react-icons/bs";

const HeaderSection = ({ title, subtitle, imagePath, imagePosition = "right", tasks = [] }) => {
    const desktopOrderClass = imagePosition === "left" ? "lg:flex-row-reverse" : "lg:flex-row";

    return (
        <section
            className={`
                pl-4 sm:pl-4 lg:pl-4 xl:pl-4 2xl:pl-24   pr-4
                  flex flex-col ${desktopOrderClass} w-full 
             justify-center gap-4 items-start lg:pt-8 pt-5`}
        >
            {/* Texte */}
            <div className="flex flex-col gap-5 lg:w-1/2 w-full items-start">
                <p className="font-bold font-Poppins text-blue-800 
                text-2xl sm:text-2xl md:text-2xl lg:text-4xl text-start 
                leading-snug lg:leading-[4rem]">
                    {title}
                </p>

                {subtitle && (
                    <p className="font-semibold font-Poppins text-base sm:text-md md:text-lg lg:text-xl text-blue-700 w-full text-start leading-relaxed">
                        {subtitle}
                    </p>
                )}

                {tasks.length > 0 && (
                    <ul className="   flex flex-col gap-2 mt-3 w-full">
                        {tasks.map((task, i) => (
                            <li
                                key={i}
                                className="flex items-center text-start gap-2 text-blue-600"
                            >
                                <BsDot className="text-color1" />
                                <span className="text-base font-medium sm:text-md md:text-lg lg:text-xl">{task}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {/* Image */}
            <div
                className={`lg:w-1/2 w-full flex items-center
                ${imagePosition === "left" ? "lg:justify-start" : "justify-start"}`}
            >
                <img
                    src={imagePath}
                    alt="gestion freelance"
                    className="w-full h-auto rounded-2xl max-h-[50vh] lg:max-h-[80vh] lg:max-w-[95%] object-contain"
                />
            </div>
        </section>
    );
};

export default HeaderSection;
